import {addEffect} from 'scripting/commands/effects.js';

export const buildRack = (sequencerEngine, rack, config, name) => {
    // first add any effets
    for (let fx in config) {
        if (fx === name || fx === "in" || fx === "out") {
            continue;
        }
        console.log("adding", fx,rack);
        addEffect(sequencerEngine, fx, rack);
   }

    for (let fromNode in config) {
        let adj = config[fromNode];
        if (!Array.isArray(adj)) {
            adj = [adj];
        }

        if (fromNode === "in") {
            fromNode = undefined;
        } else {
            fromNode = rack.effects.find(
                e => e.name === fromNode);
        }

        let outputNumber = 0;
        for (let toNode of adj) {
            if (toNode === "out") {
                toNode = undefined;
            } else {
                toNode = rack.effects.find(
                   e => e.name === toNode);
            }
            rack.connectNodes(fromNode, toNode, outputNumber++);
        }
    }
};
